"use client";
import { useRef, useState } from "react";
import { useSearchParams } from "solito/navigation";
import GatheringAccessEnum from "src/api/graphql/__generated__/enums/GatheringAccessEnum";
import GatheringPrivacy from "src/api/graphql/__generated__/enums/GatheringPrivacy";
import { GatheringInitialEntryFragmentFragment } from "src/api/graphql/__generated__/graphql";
import Loading from "src/components/Loading";
import OpacityView from "src/components/OpacityView";
import useMountEffect from "src/hooks/useMountEffect";
import useJoinGathering from "src/screens/GatheringEntry/hooks/useJoinGathering";
import { AnimatePresence } from "src/swsh-native";
import GatheringPreview from "./GatheringPreview";

const GatheringJoin = ({ gathering }: { gathering: GatheringInitialEntryFragmentFragment }) => {
	const searchParams = useSearchParams<{
		join?: string;
		callback?: string;
	}>();
	const { joinGathering } = useJoinGathering({
		name: gathering.name,
		refCode: gathering.refCode,
		collectData: gathering.collectData,
	});
	const [hasPassword, setHasPassword] = useState(
		gathering?.privacy?.includes(GatheringPrivacy.PasswordRequired) || false,
	);
	const join = useRef(searchParams?.get("join") === "true");
	const [joining, setJoining] = useState(join.current);

	useMountEffect(() => {
		if (join.current) {
			(async () => {
				setJoining(true);
				const retGathering = await joinGathering();
				setJoining(false);
				if (retGathering?.privacy?.includes(GatheringPrivacy.PasswordRequired)) {
					setHasPassword(true);
				}
			})();
		}
	}, []);

	return (
		<AnimatePresence>
			{(() => {
				if (joining) {
					return (
						<OpacityView
							entering={false}
							exiting={true}
							style={{
								flex: 1,
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<Loading />
						</OpacityView>
					);
				}
				if (gathering.access === GatheringAccessEnum.None || !gathering.access) {
					return (
						<OpacityView
							entering={true}
							exiting={false}
							style={{
								flex: 1,
							}}
						>
							<GatheringPreview
								gathering={gathering}
								shouldDisplayUnlock={hasPassword}
							/>
						</OpacityView>
					);
				}
				return null;
			})()}
		</AnimatePresence>
	);
};
export default GatheringJoin;
